import { observable } from "@legendapp/state";
import type { ChatClipSourceResolved } from "@/utils/computeChatClipSource";

/** Chat → document clip context (URL / thread). Updated from ChatWorkspace without React subscriptions in the chat tree. */
export const chatClipSource$ = observable<ChatClipSourceResolved>({
  threadId: null,
  sourceUrl: null,
  sourceLabel: null,
});
